<template>
  <div>
    <v-card elevation="6">
      <div class="pa-3">
        <div class="grid_select">
          <div class="grid_header_sell">
            <div class="mx-auto">
              <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_total_sell" :src="img_total_sell"/>
            </div>
            <div class="pt-3 pl-2" style="font-size: 26px"><b>รวมยอดขายทั้งหมด</b></div>
          </div>
          <div class="ma-2">
            <v-select color="#86bc3a" @input="dump_data_select()" :items="year_arr" item-text="show_year" item-value="year_eng" v-model="selected_year_sell" prepend-inner-icon="mdi-calendar-month-outline" label="ปี พ.ศ." hide-details="auto" outlined></v-select>
          </div>
        </div>
      </div>
      <div class="pa-3" style="height: 40vh !important">
        <canvas id="myChartSell"></canvas>
      </div>
    </v-card>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import img_total_sell from "@/assets/increasing_refund.png";
import {HTTP} from "@/axios";

export default {
  name: "Summary_total_sale",
  data() {
    return {
      console_chart_sell: null,
      img_total_sell: img_total_sell,
      selected_year_sell: null,
      year_arr: [],
      graph_balance_list: [],
      graph_delivery_list: [],
      myChartSell: null,
      year: [
        {id: 1, name: 'ปี 2565'},
        {id: 2, name: 'ปี 2564'},
        {id: 3, name: 'ปี 2563'},
        {id: 4, name: 'ปี 2562'},
        {id: 5, name: 'ปี 2561'},
      ],
    }
  },
  methods: {
    async year_function() {
      this.year_arr = []
      let arr_year = [0, 1, 2]
      let count_year = new Date()
      let full_year = count_year.getFullYear()
      for (let i = 0; i < arr_year.length; i++) {
        let count_th = ((full_year + 543) - i);
        let count_eng = ((full_year) - i);
        this.year_arr.push({
          id: i,
          year_th: count_th,
          year_eng: count_eng,
          show_year: 'ปี ' + count_th,
        })
      }
      this.selected_year_sell = this.year_arr[0].year_eng
      await this.dump_data_select()
    },
    async dump_data_select() {
      this.graph_balance_list = []
      this.graph_delivery_list = []
      await HTTP.post('/dashboards/orders', {
        year: this.selected_year_sell
      }).then((res) => {
        if (res.data.success === true) {
          res.data.object.forEach((data) => {
            this.graph_balance_list.push(parseFloat(data.total))
            this.graph_delivery_list.push(parseFloat(data.delivery))
          })
          if (this.myChartSell !== null) {
            this.myChartSell.destroy()
          }
          this.chart_sell()
        }
      })
    },
    chart_sell() {
      let data = {
        labels: this.$store.state.monthThai,
        datasets: [
          {
            label: 'ยอดเงิน',
            data: this.graph_balance_list,
            borderColor: '#8CC63E',
            backgroundColor: '#8CC63E',
            fill: false
          },
          {
            label: 'เดลิเวอรี่',
            data: this.graph_delivery_list,
            borderColor: '#1976D2',
            backgroundColor: '#1976D2',
            fill: false
          },
        ]
      }
      let config = {
        type: 'bar',
        data: data,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: {
                stacked: true
            },
            y: {
                stacked: true
            }
          }
        }
      }
      const ctx = document.getElementById('myChartSell').getContext('2d');
      this.myChartSell = new Chart(ctx, config)
    },
  },
  mounted() {
    this.year_function()
  }
}
</script>

<style scoped>
.grid_select {
  display: grid;
  grid-template-columns: 80% 20%;
}
.grid_header_sell {
  display: grid;
  grid-template-columns: 10% 90%;
}
@media only screen and (max-width: 1180px) {
  .grid_select {
    display: grid;
    grid-template-columns: 70% 30%;
  }
  .grid_header_sell {
    display: grid;
    grid-template-columns: 22% 78%;
  }
}
@media only screen and (max-width: 500px) {
  .grid_select {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_header_sell {
    display: grid;
    grid-template-columns: 25% 75%;
  }
}
</style>
